import { Outlet } from "react-router";

import { Toaster } from "@/components/ui/sonner";

// @ts-ignore
import licitigo_logo from "../../assets/licitigo_logo.svg";

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-muted px-4 py-8">
      <img
        className="mb-8 w-44"
        src={licitigo_logo}
        alt="Licitigo"
      />
      <div className="w-full max-w-md overflow-hidden rounded-3xl bg-card p-8 shadow-sm sm:p-12">
        <Outlet />
      </div>
      <Toaster richColors position="top-right" />
    </div>
  );
}
